import { toAsset } from '@cp/shared/image';
import ImgTA from './assets/TA-team.jpg';
import ImgGM from './assets/GM-team.jpg';
import ImgBD from './assets/BD-team.jpg';
import ImgChD from './assets/ChD-team.jpg';
import ImgIM from './assets/IM-team.jpg';
import ImgRA from './assets/RA-team.jpg';
import ImgShD from './assets/ShD-team.jpg';
import ImgSV from './assets/SV-team.jpg';

export const teamData = [
  {
    asset: toAsset(ImgTA),
    name: 'Титов Андрей',
    jobTitle: 'Директор, основатель',
    gender: 'Male',
  },
  {
    asset: toAsset(ImgChD),
    name: 'Чалый Дмитрий',
    jobTitle: 'Программист',
    gender: 'Male',
  },
  {
    asset: toAsset(ImgShD),
    name: 'Дарья Шарова',
    jobTitle: 'Оператор техподдержки',
    gender: 'Female',
  },
  {
    asset: toAsset(ImgGM),
    name: 'Маргарита Гринь',
    jobTitle: 'Frontend-разработчик',
    gender: 'Female',
  },
  {
    asset: toAsset(ImgSV),
    name: 'Самсыкина Виолетта',
    jobTitle: 'Product-менеджер',
    gender: 'Female',
  },
  {
    asset: toAsset(ImgBD),
    name: 'Дарья Болтрик',
    jobTitle: 'Модератор сайта',
    gender: 'Female',
  },
  {
    asset: toAsset(ImgRA),
    name: 'Руденко Алексей',
    jobTitle: 'Backend-разработчик',
    gender: 'Female',
  },
  {
    asset: toAsset(ImgIM),
    name: 'Инна Мельникова',
    jobTitle: 'Семейный психолог',
    gender: 'Female',
  },
];
